import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Auth0Hook$loginWithRedirect$ref(p0) {
  return constructCallableReference((p0_0) => {
    p0.loginWithRedirect(p0_0);
    return Unit_instance;
  }, 1, 0, 140, 'loginWithRedirect', [p0]);
}
function Auth0Hook$logout$ref(p0) {
  return constructCallableReference((p0_0) => {
    p0.logout(p0_0);
    return Unit_instance;
  }, 1, 0, 141, 'logout', [p0]);
}
//region block: exports
export {
  Auth0Hook$loginWithRedirect$ref as Auth0Hook$loginWithRedirect$ref3f5fbsxdelfs7,
  Auth0Hook$logout$ref as Auth0Hook$logout$ref3umm3i815d9x8,
};
//endregion

//# sourceMappingURL=External.mjs.map
